<template>
  <main class="inicio">

    <NavbarMain />
    <SliderComp />
    <div class="container">
      <div v-show="showProgressRutas">
        <ProgressBar mode="indeterminate" style="height: 0.5em" />
      </div>

      <article class="box-rutas">
        <section class="column-rutas skin-berlinave">Origen</section>
        <section class="column-rutas skin-berlinave">Destino</section>

        <DropDown v-model="rutaorigen" :options="origenes" @change="consultarDestinos()" optionLabel="detalle"
          placeholder="Seleccionar Origen" />

        <DropDown class="w-full" v-model="rutadestino" :options="origenes" @change="consultarOrigenesyDestinos()"
          optionLabel="detalle" placeholder="Seleccionar Destino" />

      </article>
    </div>

    <div class="contenedor-rutas" v-show="!showProgressRutas">

      <div v-for="ruta in rutas" :key="ruta.id" class="card">
        <div class="component-img">
          <img class="imagen-card" :src="require(`@/assets/${ruta.rdis_img_destino}`)" alt="NO IMAGEN" />
          <h4 class="name-card-float">{{ ruta.destino }}</h4>
        </div>
        <div class="component-detail">
          <p>Desde {{ ruta.origen }}</p>
          <h4>{{ ruta.tarifa }} COP</h4>
        </div>
      </div>
    </div>

    <div class="contenedor-rutas" v-show="showProgressRutas">
      <SkeletonPrime height="18rem" v-show="showProgressRutas"></SkeletonPrime>
      <SkeletonPrime height="18rem" v-show="showProgressRutas"></SkeletonPrime>
      <SkeletonPrime height="18rem" v-show="showProgressRutas"></SkeletonPrime>
      <SkeletonPrime height="18rem" v-show="showProgressRutas"></SkeletonPrime>
      <SkeletonPrime height="18rem" v-show="showProgressRutas"></SkeletonPrime>
      <SkeletonPrime height="18rem" v-show="showProgressRutas"></SkeletonPrime>
    </div>

    <div class="footer-inicio">
      <FooterComp />
    </div>
  </main>
</template>

<script>


export default {
  name: "InicioView",

  data() {
    return {
      showProgressRutas: false,
      origenes: [],
      rutas: [],
      destinos: [],
      rutaorigen: { id: 1, detalle: "SANTA MARTA" },
      rutadestino: null,
    };
  },

  components: {

  },

  created: function () {
    this.getOrigenes();
    this.consultarDestinos();
  },

  computed: {
    //<!-- :src="require(`@/assets/${publicacion.imagen}`)" -->
  },

  methods: {
    getOrigenes: async function () {
      this.showProgressRutas = true;
      let vue = this;
      await this.axios
        .get("model/rutasdisponibles.php?dato=getciudades")
        .then(function (response) {
          vue.origenes = response.data;
        })
        .catch((error) => {
          this.$utilidad.printConsole(error);
        })
        .then(function () {
          vue.showProgressRutas = false;
        });
    },

    consultarDestinos: async function () {
      this.showProgressRutas = true;

      let vue = this;
      await this.axios
        .get(
          "model/rutasdisponibles.php?dato=getrutasxorigen&ruta_origen=" +
          this.rutaorigen.id
        )
        .then(function (response) {
          vue.rutas = response.data;
        })
        .catch((error) => {
          this.$utilidad.printConsole(error);
        })
        .then(function () {
          vue.showProgressRutas = false;
        });
    },

    consultarOrigenesyDestinos: async function () {
      this.showProgressRutas = true;
      let vue = this;
      await this.axios
        .get(
          "model/rutasdisponibles.php?dato=getrutasxorigenydestino&ruta_origen=" +
          this.rutaorigen.id +
          "&ruta_destino=" +
          this.rutadestino.id
        )
        .then(function (response) {
          vue.rutas = response.data;
        })
        .catch((error) => {
          this.$utilidad.printConsole(error);
        })
        .then(function () {
          vue.showProgressRutas = false;
        });
    },
  },
};
</script>

<style scope>


.contenedor-rutas {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  width: 90%;
  margin: auto;
}


.card {
  display: flex;
  flex-direction: column;
  box-shadow: 5px 0 10px rgba(0, 0, 0, 0.6);
  border-radius: 10px;
}

.card:hover {
  opacity: 0.6;
  cursor: pointer;
  transition: 1s;
  /* transform: rotateY(20deg); */
}

.component-img {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  flex-grow: 2;
}

.component-detail {
  flex-grow: 1;
  padding: 0.5rem 1rem;
}

.imagen-card {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  border-radius: 10px 10px 0 0;
}

.name-card-float {
  position: absolute;
  bottom: 0;
  left: 1rem;
  color: #fff;
  padding: 0.5rem;
  background-color: rgba(0, 0, 0, 0.6);
  box-shadow: 5px 0 10px rgba(0, 0, 0, 0.6);
  border-radius: 9999px;
  font-size: 1.2rem;
}


.box-rutas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  width: 90%;
  margin: 1rem auto;
  padding: 0.5rem;
  border-radius: 1rem;
}

.column-rutas {
  padding: 0.5rem;
  font-size: 1.2rem;
  border-radius: 1rem 1rem 0 0;
}


@media screen and (max-width: 992px) {
  .contenedor-rutas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 85%;
    margin: auto;
  }

}

@media screen and (max-width: 768px) {
  .contenedor-rutas {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    width: 85%;
    margin: auto;
  }

}

.footer-inicio {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
}


.skin-berlinave {
  background-color: #004d27 !important;
  color: white !important;
  border-right: #fff 1px solid;
}
</style>
